import { render, staticRenderFns } from "./ConsentRevocation.vue?vue&type=template&id=773dcc4a&"
import script from "./ConsentRevocation.vue?vue&type=script&lang=js&"
export * from "./ConsentRevocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports